var map = {
	"./CDA/About/routes/public.js": "c509",
	"./CDA/Contact/routes/public.js": "7e6b",
	"./CDA/Home/routes/public.js": "0e46",
	"./CDA/Programmes/routes/public.js": "6548",
	"./CDA/Strategy/routes/public.js": "c181"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2da1";